import ApiEndpointConstants from "../constants/ApiEndpointConstants";
import api from "./API";

export const GetOrder = (id) => {
    return api.post(`${ApiEndpointConstants.GET_ORDER_DETAIL}`,{id})
}